"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayAssociationFailureNotification = displayAssociationFailureNotification;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _immutable = require("immutable");

var _AssociationTypeToAssociationTypeId = _interopRequireDefault(require("crm_data/associations/AssociationTypeToAssociationTypeId"));

var _links = _interopRequireDefault(require("crm_internal/config/links"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _Raven = _interopRequireDefault(require("Raven"));

var CONFIRM_ACTION_SAVED = 'interactionWithTimelineEngagement.confirmAction.saved';
var CONFIRM_ACTION_SENT = 'interactionWithTimelineEngagement.confirmAction.sent';
var associationTypeMap = (0, _immutable.Map)({
  ENGAGEMENT_TO_COMPANY: {
    associationRecordTranslationKey: 'interactionWithTimelineEngagement.recordType.company',
    objectType: _ObjectTypes.COMPANY
  },
  ENGAGEMENT_TO_CONTACT: {
    associationRecordTranslationKey: 'interactionWithTimelineEngagement.recordType.contact',
    objectType: _ObjectTypes.CONTACT
  },
  ENGAGEMENT_TO_DEAL: {
    associationRecordTranslationKey: 'interactionWithTimelineEngagement.recordType.deal',
    objectType: _ObjectTypes.DEAL
  },
  ENGAGEMENT_TO_TICKET: {
    associationRecordTranslationKey: 'interactionWithTimelineEngagement.recordType.ticket',
    objectType: _ObjectTypes.TICKET
  }
});
var engagementTypeI18nMap = (0, _immutable.Map)({
  note: {
    engagementTranslationKey: 'interactionWithTimelineEngagement.engagementType.note',
    confirmActionTranslationKey: CONFIRM_ACTION_SAVED
  },
  call: {
    engagementTranslationKey: 'interactionWithTimelineEngagement.engagementType.call',
    confirmActionTranslationKey: CONFIRM_ACTION_SAVED
  },
  task: {
    engagementTranslationKey: 'interactionWithTimelineEngagement.engagementType.task',
    confirmActionTranslationKey: CONFIRM_ACTION_SAVED
  },
  email: {
    engagementTranslationKey: 'interactionWithTimelineEngagement.engagementType.email',
    confirmActionTranslationKey: CONFIRM_ACTION_SENT
  },
  meeeting: {
    engagementTranslationKey: 'interactionWithTimelineEngagement.engagementType.meeting',
    confirmActionTranslationKey: CONFIRM_ACTION_SENT
  }
});

var getassociationRecordInfo = function getassociationRecordInfo(associationCreateFailures) {
  try {
    var associationRelationship = _AssociationTypeToAssociationTypeId.default.findKey(function (relationshipId) {
      return relationshipId === associationCreateFailures[0].association.associationTypeId;
    });

    var _associationTypeMap$g = associationTypeMap.get(associationRelationship),
        associationRecordTranslationKey = _associationTypeMap$g.associationRecordTranslationKey,
        objectType = _associationTypeMap$g.objectType;

    var associationRecordType = _I18n.default.text(associationRecordTranslationKey);

    var recordId = associationCreateFailures[0].association.toObjectId;

    var associationRecordLink = _links.default.fromObjectTypeAndId(objectType, recordId);

    return {
      associationRecordType: associationRecordType,
      associationRecordLink: associationRecordLink
    };
  } catch (error) {
    _Raven.default.captureException('An invalid associationTypeId was passed in.', {
      extra: {
        error: error,
        associationCreateFailures: associationCreateFailures
      }
    });

    throw error;
  }
};

var getTranslationKeyAndOptions = function getTranslationKeyAndOptions(associationCreateFailures, createdEngagement, extraData) {
  try {
    var type = createdEngagement.engagement.get('type').toLowerCase();

    var _engagementTypeI18nMa = engagementTypeI18nMap.get(type),
        confirmActionTranslationKey = _engagementTypeI18nMa.confirmActionTranslationKey,
        engagementTranslationKey = _engagementTypeI18nMa.engagementTranslationKey;

    var confirmAction = _I18n.default.text(confirmActionTranslationKey);

    var engagementType = _I18n.default.text(engagementTranslationKey);

    if (associationCreateFailures.length > 1) {
      return {
        translationKey: 'interactionWithTimelineEngagement.title.associatedRecord.many',
        options: {
          engagementType: engagementType,
          confirmAction: confirmAction,
          number: associationCreateFailures.length
        }
      };
    }

    if (extraData.get('subjectId') === associationCreateFailures[0].association.toObjectId) {
      return {
        translationKey: 'interactionWithTimelineEngagement.title.record',
        options: {
          engagementType: engagementType,
          confirmAction: confirmAction
        }
      };
    }

    var _getassociationRecord = getassociationRecordInfo(associationCreateFailures, createdEngagement),
        associationRecordLink = _getassociationRecord.associationRecordLink,
        associationRecordType = _getassociationRecord.associationRecordType;

    return {
      translationKey: 'interactionWithTimelineEngagement.title.associatedRecord.single_jsx',
      options: {
        engagementType: engagementType,
        confirmAction: confirmAction,
        associationRecordLink: associationRecordLink,
        associationRecordType: associationRecordType
      }
    };
  } catch (error) {
    _Raven.default.captureException('An nonexistent record, engagement, or association type was passed in.', {
      extra: {
        error: error,
        createdEngagement: createdEngagement
      }
    });

    return {
      translationKey: 'interactionWithTimelineEngagement.default_error',
      options: {}
    };
  }
};

var getTitleText = function getTitleText(createdEngagement, associationCreateFailures, extraData) {
  var _getTranslationKeyAnd = getTranslationKeyAndOptions(associationCreateFailures, createdEngagement, extraData),
      translationKey = _getTranslationKeyAnd.translationKey,
      options = _getTranslationKeyAnd.options;

  return _react.default.createElement(_FormattedJSXMessage.default, {
    message: "" + translationKey,
    elements: {
      Link: _UILink.default
    },
    options: options
  });
};

function displayAssociationFailureNotification(createdEngagement, associationCreateFailures, extraData) {
  var message = _react.default.createElement(_FormattedJSXMessage.default, {
    message: "interactionWithTimelineEngagement.message_jsx",
    elements: {
      Link: _UILink.default
    }
  });

  var titleText = getTitleText(createdEngagement, associationCreateFailures, extraData);

  _FloatingAlertStore.default.addAlert({
    message: message,
    titleText: titleText,
    type: 'danger'
  });
}